import { render, staticRenderFns } from "./OneVillageOneProductBase.vue?vue&type=template&id=7155549a&scoped=true&"
import script from "./OneVillageOneProductBase.vue?vue&type=script&lang=js&"
export * from "./OneVillageOneProductBase.vue?vue&type=script&lang=js&"
import style0 from "./OneVillageOneProductBase.vue?vue&type=style&index=0&id=7155549a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7155549a",
  null
  
)

export default component.exports